<template>
    <div v-if="nodeInfo != null">
        <div class="object-titlebox">
            <div class="object-titlebox-left" v-t="'message.layer_title'"></div>
            <div v-if="nodeInfo.id == 1" class="object-titlebox-right">
                <button class="transparent-button" type="button" v-on:click="rootNode(0)"><span class="object-command-disabled"><img src="../assets/delete.svg"/><span v-t="'message.common_action_delete'"></span></span></button>
                <button class="transparent-button" type="button" v-on:click="rootNode(1)"><span class="object-command-disabled"><img src="../assets/move.svg"/><span v-t="'message.common_action_move'"></span></span></button>
                <button class="transparent-button" type="button" v-on:click="rootNode(2)"><span class="object-command-disabled"><img src="../assets/edit.svg"/><span v-t="'message.common_action_edit'"></span></span></button>
            </div>
            <div v-else class="object-titlebox-right">
                <button class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck('DeleteNode')"><img src="../assets/delete.svg"/><span class="important-command-text" v-t="'message.common_action_delete'"></span></button>
                <button class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck('MoveNode')"><img src="../assets/move.svg"/><span class="normal-command-text" v-t="'message.common_action_move'"></span></button>
                <button class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck('EditNode')"><img src="../assets/edit.svg"/><span class="normal-command-text" v-t="'message.common_action_edit'"></span></button>
            </div>
        </div>
        <table width=100%>
            <tr>
                <td width=50% class="object-item" v-t="'message.item_layerId'"></td>
                <td class="object-value">{{ nodeInfo.name }}</td>
            </tr>
        </table>
        <div class="object-titlebox">
            <div class="object-titlebox-left">
                <span v-t="{ path: 'message.layer_title_acl_ro', args: { name: nodeInfo.name } }"></span>
                <el-tooltip effect="dark" placement="top-start">
                    <div slot="content" style="text-align:left" v-t="'message.layer_hint_acl_ro'"></div>
                    <img class="icon-help" style="height:15px" :src="require('@/assets/icon_help.svg')"/>
                </el-tooltip>
            </div>
            <div class="object-titlebox-right">
                <template v-if="showAclEditCommand">
                    <div v-if="aclInfo.roUsers.length==0">
                        <button class="transparent-button" type="button" v-on:click="showAddAclDialog(0)"><img src="../assets/add_user.svg"/><span class="normal-command-text" v-t="'message.layer_action_add_acl_ro'"></span></button>
                    </div>
                    <div v-else>
                        <button class="transparent-button" type="button" v-on:click="showAddAclDialog(0)"><img src="../assets/edit.svg"/><span class="normal-command-text" v-t="'message.layer_action_edit_acl_ro'"></span></button>
                    </div>
                </template>
            </div>
        </div>
        <table width=100%>
        <tr class="acluser-record" v-for="roUser in aclInfo.roUsers">
          <td class="object-item">
          <div class="object-userlist-left">
            <div v-if="showAclDeleteCommand" class="object-userlist-right">
                <button class="item-record-button" type="button" v-on:click="deleteConfirmAcl(3,roUser.id,roUser)"><img src="../assets/icon_delete_user.svg"/></button>
            </div>
            <span v-if="roUser.displayName == null">
                {{ roUser.userName }}
            </span>
            <span v-else>
                {{ roUser.userName+ "@" + roUser.tenantName + " / " + roUser.displayName }}
            </span>
          </div>
          </td>
        </tr>
        </table>
        <div class="object-titlebox">
            <div class="object-titlebox-left">
                <span v-t="{ path: 'message.layer_title_acl_rw', args: { name: nodeInfo.name } }"></span>
                <el-tooltip effect="dark" placement="top-start" style="clear:both">
                    <div slot="content" style="text-align:left" v-t="'message.layer_hint_acl_rw'"></div>
                    <img class="icon-help" style="height:15px" :src="require('@/assets/icon_help.svg')"/>
                </el-tooltip>
            </div>
            <div class="object-titlebox-right">

                <template v-if="showAclEditCommand">
                    <div v-if="aclInfo.rwUsers.length==0">
                        <button class="transparent-button" type="button" v-on:click="showAddAclDialog(1)">
                            <img src="../assets/add_user.svg"/>
                            <span class="normal-command-text" v-t="'message.layer_action_add_acl_rw'"></span>
                        </button>
                    </div>
                    <div v-else>
                        <button class="transparent-button" type="button" v-on:click="showAddAclDialog(1)">
                            <img src="../assets/edit.svg"/>
                            <span class="normal-command-text" v-t="'message.layer_action_edit_acl_rw'"></span>
                        </button>
                    </div>
                </template>

            </div>
        </div>
        <table width=100%>
        <tr class="acluser-record" v-for="rwUser in aclInfo.rwUsers">
            <td v-if="!isRwForLinkedNode(rwUser.id)" class="object-item">
                <div class="object-userlist-left">
                    <div v-if="showAclDeleteCommand" class="object-userlist-right">
                        <button class="item-record-button" type="button" v-on:click="deleteConfirmAcl(4,rwUser.id,rwUser)"><img src="../assets/icon_delete_user.svg"/></button>
                    </div>
                    <span v-if="rwUser.displayName == null">
                        {{ rwUser.userName }}
                    </span>
                    <span v-else>
                        {{ rwUser.userName + "@" + rwUser.tenantName + " / " + rwUser.displayName }}
                    </span>
                </div>
            </td>
        </tr>
        </table>
        <div v-if="isExistExportedTenant()" class="object-titlebox">
            <table width="100%">
                <tr>
                    <td style="padding: 7px 0px 7px 10px;padding-left: 20px;color: #848991;font-size: 12px;">
                        <span v-t="{ path: 'message.layer_title_acl_link', args: { name: nodeInfo.name } }"></span>
                        <el-tooltip effect="dark" placement="top-start" style="clear:both">
                            <div slot="content" style="text-align:left" v-t="'message.layer_hint_acl_link'"><br></div>
                            <img class="icon-help" style="height:15px" :src="require('@/assets/icon_help.svg')"/>
                        </el-tooltip>
                    </td>
                    <td style="padding: 7px 10px 7px 0px;color: #848991;font-size: 12px;text-align:right">

                        <template v-if="showAclEditCommand">
                            <div v-if="nodeInfo.id != 1">
                                <div v-if="aclInfo.linkUsers.length==0">
                                    <button class="transparent-button" type="button" v-on:click="showAddAclDialog(2)">
                                        <img src="../assets/add_user.svg"/>
                                        <span class="normal-command-text" v-t="'message.layer_action_add_acl_link'"></span>
                                    </button>
                                </div>
                                <div v-else>
                                    <button class="transparent-button" type="button" v-on:click="showAddAclDialog(2)">
                                        <img src="../assets/edit.svg"/>
                                        <span class="normal-command-text" v-t="'message.layer_action_edit_acl_link'"></span>
                                    </button>
                                </div>
                            </div>
                        </template>

                    </td>
                </tr>
            </table>
        </div>
        <table width=100%>
            <tr class="acluser-record" v-for="linkUser in aclInfo.linkUsers">
                <td class="object-item">
                    <div class="object-userlist-left">
                        <div v-if="showAclDeleteCommand && nodeInfo.id != 1" class="object-userlist-right">
                            <button class="item-record-button" type="button" v-on:click="deleteConfirmAcl(5,linkUser.id,linkUser)"><img src="../assets/icon_delete_user.svg"/></button>
                        </div>
                        {{ linkUser.userName + "@" + linkUser.tenantName + " / " + linkUser.displayName }}
                    </div>
                </td>
            </tr>
        </table>
        <!-- ###################################### -->
        <!-- Two phase method                       -->
        <!-- ###################################### -->
        <div v-if="isTwoPhaseMethodActive()" class="object-titlebox">
            <div class="object-titlebox-left">
                <span v-t="{ path: 'message.layer_title_user_two_phase_method', args: { name: nodeInfo.name } }"></span>
                <el-tooltip effect="dark" placement="top-start" style="clear:both">
                    <div slot="content" style="text-align:left" v-t="'message.layer_hint_two_phase_method'"><br></div>
                    <img class="icon-help" style="height:15px" :src="require('@/assets/icon_help.svg')"/>
                </el-tooltip>
            </div>
            <div class="object-titlebox-right">
                <button class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck('EditTwoPhaseMethod')"><img src="../assets/edit.svg"/><span class="normal-command-text" v-t="'message.layer_action_edit_two_phase_method'"></span></button>
            </div>
        </div>
        <!-- ###################################### -->
        <!-- Client setting                         -->
        <!-- ###################################### -->
        <div v-if="appData.enableConfigOption && appData.clientSettingsForEachNode ">
            <div class="object-titlebox">
                <div class="object-titlebox-left">
                    <span v-t="{ path: 'message.layer_title_user_client_setting', args: { name: nodeInfo.name } }"></span>
                    <el-tooltip effect="dark" placement="top-start">
                        <div slot="content" style="text-align:left" v-t="'message.layer_hint_client_setting'"></div>
                        <img class="icon-help" style="height:15px" :src="require('@/assets/icon_help.svg')"/>
                    </el-tooltip>
                </div>
                <div class="object-titlebox-right">
                    <button class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck('EditNodeClientSetting')"><img src="../assets/edit.svg"/><span class="normal-command-text" v-t="'message.common_action_edit'"></span></button>
                </div>
            </div>
            <table width=100%>
                <tr>
                    <td width=50% class="object-item" v-t="'message.item_client_setting_name'"></td>
                    <td class="object-value">{{ clientSettingName }}</td>
                </tr>
            </table>
        </div>

        <deletenode v-if="showDeleteNode" :confirmInfo="confirmInfo" @delete="deleteNode" @cancel="showDeleteNode=false"></deletenode>
        <confirmdeleteuser v-if="showConfirmDeleteAcl" :confirmInfo="confirmInfo" @delete="deleteAcl" @cancel="showConfirmDeleteAcl=false"></confirmdeleteuser>
        <movenode v-if="showMoveNode" :appData="appData" @move="moveNode" :sourceObjectId="nodeInfo.id" @cancel="showMoveNode=false"></movenode>
        <editnode v-if="showEditNode" :nodeInfo="nodeInfo" @save="modifyNode" @cancel="showEditNode=false"></editnode>
        <addacl v-if="showAddAcl" :appData="appData" :nodeInfo="nodeInfo" :aclRoUsers="aclInfo.roUsers" :aclRwUsers="aclInfo.rwUsers" :aclLinkUsers="aclInfo.linkUsers" :aclTypeIndex="aclType" @update="updateAclUsers" @cancel="showAddAcl=false"></addacl>
        <editTwoPhaseMethod v-if="showEditTwoPhaseMethod" :appData="appData" :nodeInfo="nodeInfo" :aclRwUsers="aclInfo.rwUsers" @save="updateTwoPhaseMethod" @cancel="showEditTwoPhaseMethod=false"></editTwoPhaseMethod>
        <editNodeClientSetting v-if="showEditNodeClientSetting" :nodeInfo="nodeInfo" :clientSettingId="clientSettingId" :clientSettingList="clientSettingList" @save="modifyNodeClientSetting" @cancel="showEditNodeClientSetting=false"></editNodeClientSetting>
    </div>
</template>

<script>
import Vue from 'vue';
import server from "./ServerApi.js";
import DeleteObject from "./DeleteObject.vue";
import MoveNode from "./MoveObject.vue";
import EditNode from "./EditNode.vue";
import AddACL from "./AddACL.vue";
import EditTwoPhaseMethod from "./EditTwoPhaseMethod.vue";
import commonUtil from './commonutil.js';
import constants from './constants.js';
import EditNodeClientSetting from "./EditNodeClientSetting.vue";

export default {
    data() {
      return {
        showDeleteNode: false,
        showConfirmDeleteAcl: false,
        showMoveNode: false,
        showEditNode: false,
        showAddAcl: false,
        showEditTwoPhaseMethod: false,
        showEditNodeClientSetting: false,
        nodeInfo: null ,
        loadingScreen: null,
        acl: null,
        putAclUserError: false,
        aclInfo: {
            delRoUserId: "" ,
            delRwUserId: "" ,
            roUsers: [],
            rwUsers: [],
            linkUsers: []
        },
        confirmInfo: {
            objectName: null,
            objectTitle: null
        },
        aclType: 0,
        input: {
            newName: null,
            newAcl: null,
        },
        clientSettingId: null,
        clientSettingName: "",
        clientSettingList: []
      };
    },
    methods: {
        getInfo: function() {
            this.putAclUserError = false;
            this.nodeInfo = null;
            this.$data.aclInfo.rwUsers.splice(0,this.$data.aclInfo.rwUsers.length)
            this.$data.aclInfo.roUsers.splice(0,this.$data.aclInfo.roUsers.length)
            this.$data.aclInfo.linkUsers.splice(0,this.$data.aclInfo.linkUsers.length)
            this.$data.aclInfo.delRoUserId = ""
            this.$data.aclInfo.delRwUserId = ""
            this.$data.aclInfo.delLinkUserId = ""
            this.$emit('setaclinfo',0,null);
            this.$emit('setaclinfo',1,null);
            this.$emit('setaclinfo',2,null);
            //
            this.loadingScreen = this.loadingScreen = this.$loading({
                    lock: true ,
                    text: 'Loading data ...' ,
                    spinner: 'el-icon-loading' ,
                    background: 'rgba(0, 0, 0, 0)'
            });

            let self = this;
            server.post('/getinfo', {tenantId: this.appData.tenantList[0].tenantId, id: this.selectedNode.node.data.id})
                .then((res) => {
                    if (res.data.status == constants.STATUS_SUCCESS) {
                        if (self.selectedNode.node.data.id != 1) {
                            if (self.selectedNode.node.parent.data.id != res.data.pid) {
                                commonUtil.notifyMessage(self,"Warning","この階層は、他の管理者によって、別の階層に移動されています。");
                                self.$emit('reloadTree');
                                self.closeLoadingScreen();
                                return;
                            }
                        }
                        self.$data.nodeInfo = res.data
                        self.acl = JSON.parse(res.data.acl)
                        let noAclUser = true;
                        if (self.acl.rw != null) {
                            for (var i = 0 ; i< self.acl.rw.length ; i++) {
                                let aclTenantId = self.acl.rw[i].split("-")[0];
                                let aclUserId = self.acl.rw[i].split("-")[1];
                                noAclUser = false;
                                if (self.isExportedTenant(aclTenantId)) {
                                    self.getLinkUserInfo(aclTenantId, aclUserId);
                                } else {
                                    self.getRwUserInfo(aclTenantId, aclUserId);
                                }
                            }
                        }
                        if (self.acl.ro != null) {
                            for (var i = 0 ; i< self.acl.ro.length ; i++) {
                                noAclUser = false;
                                self.getRoUserInfo(self.acl.ro[i].split("-")[0],self.acl.ro[i].split("-")[1]);
                            }
                        }
                        if (noAclUser) {
                            self.closeLoadingScreen();
                        }
                        if (this.appData.clientSettingsForEachNode) {
                            if (res.data.clientSettingId != null) {
                                self.clientSettingId = JSON.parse(res.data.clientSettingId);
                                self.getClientSettingName(self.clientSettingId);
                            } else {
                                self.clientSettingId = 0;
                                self.clientSettingName = commonUtil.getMessageText(self.$i18n,"item_value_noSetting");
                            }
                        }
                    } else {
                        switch(res.data.status) {
                            case constants.STATUS_ERROR_DENIED:
                                commonUtil.notifyMessage(self,"Warning","選択された階層に読み込み権限がないため、階層情報が読み込めません。");
                                break;
                            case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                                commonUtil.notifyMessage(self,"Warning","この階層は、他の管理者によって削除されています。");
                                break;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getInfo").replace("{code}",res.data.status));
                                break;
                        }
                        self.$emit('reloadTree');
                        self.closeLoadingScreen();
                    }
                })
                .catch( function ( error ) {
                    self.closeLoadingScreen();
                    commonUtil.putExceptionErrorMessage(self, "getInfo", error);
                });
        },
        async showDialogAfterWritableCheck(functionName) {
            if (functionName == "DeleteNode") {
                if (this.appData.tenantList[0].samlLayer == this.nodeInfo.id) {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_delete_saml_layer"));
                    return false;
                }
            }

            if (this.appData.csvProcessing) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_import_processing"));
                return false;
            }

            let postId = (
                // 選択された階層の権限を確認する
                functionName === "EditTwoPhaseMethod" ||
                functionName === "EditNodeClientSetting" ||
                (functionName === "AddACL" && this.selectedNode.node.id === 1) // ROOT-NODE
            ) ?
                this.selectedNode.node.data.id : this.selectedNode.$parent.node.data.id;

            let res;
            try {
                res = await server.post('/getinfo', {tenantId: this.appData.tenantList[0].tenantId, id: postId })
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "showDialogAfterWritableCheck", error);
                return false;
            }

            if (res.data.status === constants.STATUS_SUCCESS) {
                let myAclId = this.appData.tenantList[0].tenantId + "-" + this.appData.loginUserObjectId;
                let acl = JSON.parse(res.data.acl)
                if (acl.rw != null) {
                    let writable = acl.rw.find(function(element) {
                        return element == myAclId;
                    });
                    if (writable == null) {
                        if (functionName == "EditTwoPhaseMethod" || functionName == "EditNodeClientSetting") {
                            commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_select_no_writable_layer").replace('{object}',commonUtil.getMessageText(this.$i18n,"item_layer")));
                        } else {
                            commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_not_have_write_permission_on_layer").replace('{object}',commonUtil.getMessageText(this.$i18n,"item_layer")));
                        }
                        return false;
                    } else {
                        switch(functionName) {
                            case "EditNode":
                                this.showEditNode = true;
                                break;
                            case "DeleteNode":
                                this.deleteConfirmNode();
                                break;
                            case "MoveNode":
                                this.showMoveNode = true;
                                break;
                            case "EditTwoPhaseMethod":
                                this.showEditTwoPhaseMethod = true;
                                break;
                            case "EditNodeClientSetting":
                                this.getClientSettingList();
                                break;
                        }
                        return true;
                    }
                } else {
                    // no writable acl info
                    if (functionName == "EditTwoPhaseMethod" || functionName == "EditNodeClientSetting") {
                        commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_select_no_writable_layer").replace('{object}',commonUtil.getMessageText(this.$i18n,"item_layer")));
                    } else {
                        commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_not_have_write_permission_on_layer").replace('{object}',commonUtil.getMessageText(this.$i18n,"item_layer")));
                    }
                    return false;
                }
            } else {
                let errorMsg = commonUtil.getMessageText(this.$i18n,"error_server_api").replace("{functionName}","showDialogAfterWritableCheck").replace("{code}",res.data.status);
                commonUtil.notifyMessage(this,"Error",errorMsg);
                return false;
            }
        },
        showAddAclDialog: function(aclType) {
            if (this.showDialogAfterWritableCheck("AddACL")) {
                this.$data.aclType = aclType
                this.showAddAcl = true;
            }
        },
        getRwUserInfo: function(tenantId,userId) {
            let self = this;
            server.post('/getinfo', {tenantId: tenantId, id: userId})
                .then((res) => {
                    let username;
                    let displayName;
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS :         // no error
                            username = res.data.name;
                            displayName = res.data.displayName;
                            break;
                        case constants.STATUS_ERROR_DENIED:        // access denied
                            username = commonUtil.getMessageText(self.$i18n,"item_non_referable_user") + "[" + tenantId + "-" + userId +"]"
                            displayName = null;
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:       // user already deleted.
                            username = commonUtil.getMessageText(self.$i18n,"item_deleted_user") + "[" + tenantId + "-" + userId +"]"
                            displayName = null;
                            break;
                        default:
                            if (!self.putAclUserError) {
                                self.putAclUserError = true;
                                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_getting_user_information"));
                            }
                            self.closeLoadingScreen();
                            return;
                    }
                    self.pushToSorted(self.aclInfo.rwUsers, {
                        id: tenantId + "-" + userId,
                        tenantName: self.appData.tenantList[0].name,
                        userName: username,
                        displayName: displayName,
                        isRadioAdminOnlyUser: (res.data.flag & constants.ADMIN_ONLY) !== 0
                    });
                    self.checkAclLoadingFinished("rw");
                })
                .catch( function ( error ) {
                    if (!self.putAclUserError) {
                        self.putAclUserError = true;
                        commonUtil.putExceptionErrorMessage(self, "getRwUserInfo", error);
                    }
                    self.closeLoadingScreen();
                });
        },
        getRoUserInfo: function(tenantId,userId) {
            let self = this;
            server.post('/getinfo', {tenantId: tenantId, id: userId})
                .then((res) => {
                    let username;
                    let displayName;
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:         // no error
                            username = res.data.name;
                            displayName = res.data.displayName;
                            break;
                        case constants.STATUS_ERROR_DENIED:        // access denied
                            username = commonUtil.getMessageText(self.$i18n,"item_non_referable_user") + "[" + tenantId + "-" + userId +"]"
                            displayName = null;
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:       // user already deleted.
                            username = commonUtil.getMessageText(self.$i18n,"item_deleted_user") + "[" + tenantId + "-" + userId +"]"
                            displayName = null;
                            break;
                        default:
                            if (!self.putAclUserError) {
                                self.putAclUserError = true;
                                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_getting_user_information"));
                            }
                            self.closeLoadingScreen();
                            return;
                    }
                    self.pushToSorted(self.aclInfo.roUsers, {
                        id: tenantId + "-" + userId,
                        tenantName: self.appData.tenantList[0].name,
                        userName: username,
                        displayName: displayName,
                        isRadioAdminOnlyUser: (res.data.flag & constants.ADMIN_ONLY) !== 0
                    });
                    self.checkAclLoadingFinished("ro");
                })
                .catch( function ( error ) {
                    if (!self.putAclUserError) {
                        self.putAclUserError = true;
                        commonUtil.putExceptionErrorMessage(self, "getRoUserInfo", error);
                    }
                    self.closeLoadingScreen();
                });
        },
        getLinkUserInfo: function(tenantId,userId) {
            for (let exportedTenant of this.appData.exportedTenantList) {
                if (exportedTenant.tenantId == tenantId) {
                    // linked user
                    this.aclInfo.linkUsers.push({id: tenantId + "-" + userId, tenantName: exportedTenant.tenantName, userName: exportedTenant.wantUserName, displayName: exportedTenant.wantUserDisplayName });
                }
            }

            this.checkAclLoadingFinished("rw") ;

        },
        pushToSorted: function(array, element) {
            var minIndex = 0;
            var maxIndex = array.length - 1;
            var currentIndex;
            var currentElement;
            var resultIndex;

            while (minIndex <= maxIndex) {
                resultIndex = currentIndex = (minIndex + maxIndex) / 2 | 0;
                currentElement = array[currentIndex];

                let comparisonResult = commonUtil.compareStringWithNumber(currentElement.userName, element.userName);
                if (comparisonResult < 0) {
                    minIndex = currentIndex + 1;
                }
                else if (comparisonResult > 0) {
                    maxIndex = currentIndex - 1;
                }
                else {
                    array.splice(currentIndex, 0, element);
                    return;
                }
            }

            if (array.length == 0) {
                array.push(element);
                return;
            }
            if (commonUtil.compareStringWithNumber(array[currentIndex].userName, element.userName) < 0) {
                array.splice(currentIndex + 1, 0, element);
                return;
            } else {
                array.splice(currentIndex, 0, element);
                return;
            }
        },
        getConnectedTenantList() {
            let self = this;
            server.post('/gettenantconnectinfo',{type: 0})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.appData.importedTenantList = res.data.importTenantList;
                            self.appData.exportedTenantList = res.data.exportTenantList;
                            self.getInfo();
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getConnectedTenantList").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "getTenantConnectInfo", error);
                });
        },
        modifyNode: function(input) {
            this.$data.showEditNode = false;
            let self = this;
            server.post(
                '/modifynode',
                {
                    operation:
                    {
                        id: this.$data.nodeInfo.id,
                        newName: input.newName
                    }
                }
            ).then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_modified_layer"))
                    if (self.selectedNode.node.data.label != input.newName) {
                        var insertData = { data :
                                            {
                                                tenantId: self.selectedNode.node.data.tenantId,
                                                id: self.selectedNode.node.data.id,
                                                label: input.newName,
                                                type: 0,
                                                isLeaf: self.selectedNode.node.data.isLeaf
                                             }
                                         };
                        let insertIndex = self.insertNewNodeToTree(insertData, self.selectedNode.node.parent);

                        if (self.selectedNode.node.childNodes.length > 0) {
                             self.selectedNode.node.parent.childNodes[insertIndex+1].childNodes = self.selectedNode.node.childNodes;
                        }

                        self.selectedNode.node.parent.removeChild(self.selectedNode.node);
                    }
                    self.getInfo();
                } else {
                    switch (res.data.status) {
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_by_access_denied"))
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_already_deleted").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_layer")));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","modifyNode").replace("{code}",res.data.status));
                            break;
                    }
                    return;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "modifyNode", error);
            });
        },
        modifyAcl: function(newAcl , aclType) {
            let self = this;
            server.post(
                '/modifynode',
                {
                    operation:
                    {
                        id: this.$data.nodeInfo.id,
                        newAcl: newAcl,
                    }
                }
            ).then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    let completionMessage;
                    switch(aclType) {
                        case 0:
                            completionMessage = commonUtil.getMessageText(self.$i18n,"info_modified_ro_acl");
                            break;
                        case 1:
                            completionMessage = commonUtil.getMessageText(self.$i18n,"info_modified_rw_acl");
                            break;
                        case 2:
                            completionMessage = commonUtil.getMessageText(self.$i18n,"info_modified_link_acl");
                            break;
                    }
                    commonUtil.notifyMessage(self,"Success",completionMessage);
                    self.getInfo();
                } else {
                    switch (res.data.status) {
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_not_have_write_permission_on_layer").replace('{object}',commonUtil.getMessageText(self.$i18n,"item_layer")));
                            break;
                        case constants.STATUS_ERROR_PERMISSION_DENIED:
                            commonUtil.notifyMessage(self,"Warning", commonUtil.getMessageText(self.$i18n,"error_cannot_remove_rw_acl_of_consoleadmin_on_root"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","modifyAcl").replace("{code}",res.data.status));
                            break;
                    }
                    return;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "modifyNode", error);
            });

        },
        deleteConfirmNode: function() {
            if (!this.selectedNode.node.isLeaf) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_delete_by_has_child"));
                return;
            }
            this.confirmInfo.objectTitle = commonUtil.getMessageText(this.$i18n,"item_layer");
            this.confirmInfo.objectName = this.nodeInfo.name;
            this.showDeleteNode = true;
        },
        deleteNode: function() {
            this.$data.showDeleteNode = false;
            let self = this;
            server.post(
                '/deletenode',
                {
                    operation:
                    {
                        id: this.$data.nodeInfo.id
                    }
                }
            ).then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_deleted_layer"))
                    self.selectedNode.node.parent.removeChild(self.selectedNode.node);
                } else {
                    switch (res.data.status) {
                        case constants.STATUS_ERROR_INVALID_PARAMETER:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_delete_by_has_child"));
                            break;
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_delete_by_access_denied"));
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_already_deleted").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_layer")));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","deleteNode").replace("{code}",res.data.status));
                            break;
                    }
                    return;
                }
            })
        },
        deleteConfirmAcl: function(objectType , deleteId , deleteUser) {
            if (this.appData.csvProcessing) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_import_processing"));
                return;
            }

            if (deleteUser.isRadioAdminOnlyUser ) {
                if (!this.appData.tenantAdminUser) {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"info_needs_tenant_admin_privilege"));
                    return;
                }
            }

            let objectTitle;
            if (objectType == 3) {
                // delete read only user
                objectTitle = commonUtil.getMessageText(this.$i18n,"layer_title_acl_ro").replace("{name}",this.nodeInfo.name);
                this.aclInfo.delRoUserId = deleteId;
            }
            if (objectType == 4) {
                // delete read write user
                objectTitle = commonUtil.getMessageText(this.$i18n,"layer_title_acl_rw").replace("{name}",this.nodeInfo.name);
                this.aclInfo.delRwUserId = deleteId;
                if (this.nodeInfo.id == 1) {
                    if (this.aclInfo.rwUsers.length == 1) {
                        commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_need_rw_user_on_root"));
                        return;
                    }
                }
            }
            if (objectType == 5) {
                // delete tenant-connect user
                objectTitle = commonUtil.getMessageText(this.$i18n,"layer_title_acl_link").replace("{name}",this.nodeInfo.name);
                this.aclInfo.delLinkUserId = deleteId;
            }
            this.confirmInfo.objectTitle = objectTitle;
            this.confirmInfo.objectName = deleteUser.userName + "@" + deleteUser.tenantName;
            this.showConfirmDeleteAcl = true;
        },
        deleteAcl: function() {
            var newAcl = null
            this.$data.showConfirmDeleteAcl = false;
            var acl = JSON.parse(this.$data.nodeInfo.acl)
            if (this.aclInfo.delRwUserId != "") {
                for (let i = 0 ; i < acl.rw.length ; i++) {
                    if (acl.rw[i]  == this.aclInfo.delRwUserId) {
                        acl.rw.splice(i,1);
                        this.modifyAcl(JSON.stringify(acl), 1);
                        return;
                    }
                }
            }
            if (this.aclInfo.delLinkUserId != "") {
                for (let i = 0 ; i < acl.rw.length ; i++) {
                    if (acl.rw[i]  == this.aclInfo.delLinkUserId) {
                        acl.rw.splice(i,1);
                        this.modifyAcl(JSON.stringify(acl), 2);
                        return;
                    }
                }
            }
            if (this.aclInfo.delRoUserId != "") {
                for (let i = 0 ; i < acl.ro.length ; i++) {
                    if (acl.ro[i]  == this.aclInfo.delRoUserId) {
                        acl.ro.splice(i,1);
                        this.modifyAcl(JSON.stringify(acl), 0);
                        return;
                    }
                }
            }
        },
        updateAclUsers: function(tagList) {
            var acl = JSON.parse(this.$data.nodeInfo.acl)
            this.$data.showAddAcl = false;
            let newAclKeys = [];
            switch (this.aclType) {
                case 0:
                    for (let key in tagList) {
                        newAclKeys.push(key);
                    }
                    acl.ro = newAclKeys;
                    break;
                case 1:
                    // link users + new rw users
                    for (let i = 0 ; i < this.aclInfo.linkUsers.length ; i++) {
                        let key = this.aclInfo.linkUsers[i].id;
                        Vue.set(tagList, key , {userName: this.aclInfo.linkUsers[i].userName , aclId: key});
                    }
                    for (let key in tagList) {
                        newAclKeys.push(key);
                    }
                    acl.rw = newAclKeys;
                    break;
                case 2:
                    // rw users + new link users
                    for (let i = 0 ; i < this.aclInfo.rwUsers.length ; i++) {
                        let key = this.aclInfo.rwUsers[i].id;
                        Vue.set(tagList, key , {userName: this.aclInfo.rwUsers[i].userName , aclId: key});
                    }
                    for (let key in tagList) {
                        newAclKeys.push(key);
                    }
                    acl.rw = newAclKeys;
                    break;
            }
            this.modifyAcl(JSON.stringify(acl), this.aclType);
        },
        moveCheck: function() {
            this.$data.showMoveNode = true;
        },
        moveNode: function(destinationNodeId) {
            this.$data.showMoveNode = false;
            let self = this;
            server.post(
                '/move',
                {
                    operation:
                    {
                        id: this.$data.nodeInfo.id ,
                        destinationId: destinationNodeId
                    }
                }
            ).then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_moved_layer"));
                    let parentNode = self.findNode(self.selectedNode.tree.$children[0].node , destinationNodeId);
                    if (parentNode != null) {
                        // parent node already loaded
                        var insertData = { data :
                                            {
                                                tenantId: self.selectedNode.node.data.tenantId,
                                                id: self.selectedNode.node.data.id,
                                                label: self.selectedNode.node.data.label,
                                                type: 0,
                                                isLeaf: self.selectedNode.node.data.isLeaf
                                             }
                                         };
                        this.insertNewNodeToTree(insertData, parentNode);
                    }
                    self.selectedNode.node.parent.removeChild(self.selectedNode.node);
                } else {
                    switch (res.data.status) {
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_move_by_access_denied"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","moveNode").replace("{code}",res.data.status));
                            break;
                    }
                    return;
                }
            })
        },
        showModalWindow(header, body, footer) {
            this.modalHeader = header;
            this.modalBody = body;
            this.modalFooter = footer;
            this.$data.showModal = true;
        },
        insertNewNodeToTree(insertData , parentNode) {
            if (parentNode.childNodes.length == 0) {
                parentNode.insertChild(insertData,0)
                parentNode.expand();
                return;
            }

            var insertIndex = this.getInsertIndexOfNode(parentNode , insertData.data.label);
            if (insertIndex < 0) {
                insertIndex = 0;
                parentNode.insertBefore(insertData,parentNode.childNodes[insertIndex]);
            } else {
                parentNode.insertAfter(insertData,parentNode.childNodes[insertIndex]);
            }
            return insertIndex;
        },
        findNode(rootNode , nodeId) {
            let foundNode = null;
            if (nodeId == 1) {
                return rootNode;
            }
            for (let node of rootNode.childNodes) {
                if (node.data.id == nodeId) {
                    return node;
                }
                if (node.childNodes.length > 0) {
                    let foundNode = this.findNode(node , nodeId)
                    if (foundNode != null) {
                        return foundNode;
                    }
                }
            }
            return;
        },
        getInsertIndexOfNode: function(parentNode , insertObjectName) {
            let insertIndex = -1;
            for (let i = 0 ; i < parentNode.childNodes.length ; i++) {
                if (parentNode.childNodes[i].data.type == 0) {
                    if (commonUtil.compareStringWithNumber(parentNode.childNodes[i].data.label, insertObjectName) < 0) {
                        insertIndex = i;
                    } else {
                        break;
                    }
                }
            }
            return insertIndex;
        },
        isRwForLinkedNode(userId) {
            if (this.aclInfo.linkUsers.length == 0) {
                return false;
            }
            for (let linkUser of this.aclInfo.linkUsers) {
                if (linkUser.id == userId) {
                    return true;
                }
            }
            return false;
        },
        isExportedTenant(tenantId) {
            if (this.appData.exportedTenantList.length == 0) {
                return false;
            }
            for (let exportedTenant of this.appData.exportedTenantList) {
                if ((exportedTenant.tenantId == tenantId) &
                    (exportedTenant.state == constants.TENANT_CONNECT_ESTABLISH)) {
                    return true;
                }
            }
            return false;
        },
        isExistExportedTenant() {
            if (this.appData.exportedTenantList.length == 0) {
                return false;
            }
            for (let exportedTenant of this.appData.exportedTenantList) {
                if (exportedTenant.state == constants.TENANT_CONNECT_ESTABLISH) {
                    return true;
                }
            }
            return false;
        },
        rootNode: function(operation) {
            let message;
            switch(operation) {
                case 0:
                    message = commonUtil.getMessageText(this.$i18n,"error_cannot_delete_root");
                    break;
                case 1:
                    message = commonUtil.getMessageText(this.$i18n,"error_cannot_move_root");;
                    break;
                case 2:
                    message = commonUtil.getMessageText(this.$i18n,"error_cannot_modify_root");;
                    break;
            }
            commonUtil.notifyMessage(this,"Warning",message);
        },
        checkAclLoadingFinished(aclType) {
            let finishGetAclInfo = false;
            let linkUsers = 0;
            if (this.aclInfo.linkUsers != null) {
                linkUsers = this.aclInfo.linkUsers.length;
            }

            if (aclType == "ro") {
                if (this.acl.ro.length == this.aclInfo.roUsers.length) {
                    this.$emit('setaclinfo',0,this.aclInfo.roUsers);
                    if (this.acl.rw == null) {
                        finishGetAclInfo = true;
                    } else {
                        if (this.acl.rw.length == (this.aclInfo.rwUsers.length + linkUsers)) {
                            finishGetAclInfo = true;
                        }
                    }
                }
            } else {
                if (this.acl.rw.length == (this.aclInfo.rwUsers.length + linkUsers)) {
                    this.$emit('setaclinfo',1,this.aclInfo.rwUsers);
                    if (this.acl.ro == null) {
                        finishGetAclInfo = true;
                    } else {
                        if (this.acl.ro.length == this.aclInfo.roUsers.length) {
                            finishGetAclInfo = true;
                        }
                    }
                }
            }

            if (finishGetAclInfo) {
                this.closeLoadingScreen();
            }

        },
        closeLoadingScreen() {
            if (this.loadingScreen != null) {
                this.loadingScreen.close();
                this.loadingScreen = null;
            }
        },
        isTwoPhaseMethodActive() {
            return this.appData.twoPhaseMethod;
        },
        updateTwoPhaseMethod(input, method) {
            let self = this;
            server.post('/settwophasemethod', input)
                .then((res) => {
                    this.showEditTwoPhaseMethod = false;
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            commonUtil.notifyMessage(self,"Success", commonUtil.getMessageText(self.$i18n,"info_change_two_phase_method_multiple").replace("{method}", method).replace("{success}", String(res.data.detail.success)).replace("{failure}", String(res.data.detail.failure)));
                            self.getInfo();
                            break;
                        case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                            commonUtil.notifyMessage(self,"Warning", commonUtil.getMessageText(self.$i18n,"info_change_two_phase_method_multiple").replace("{method}", method).replace("{success}", String(res.data.detail.success)).replace("{failure}", String(res.data.detail.failure)));
                            self.getInfo();
                            break;
                        case constants.STATUS_ERROR_NOT_FOUND:
                            commonUtil.notifyMessage(self,"Warning", commonUtil.getMessageText(self.$i18n,"error_no_user_information"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error", commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","updateTwoPhaseMethod").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "updateTwoPhaseMethod", error);
                });
        },
        modifyNodeClientSetting(input) {
            let self = this;
            let operations = [];
            let newClientSettingId = 0;
            if (input.newClientSettingId != 0) {
                operations.push({
                    operation: 1, // add operation
                    objectId: self.$data.nodeInfo.id
                });
                newClientSettingId = input.newClientSettingId;
            } else {
                operations.push({
                    operation: -1, // remove operation
                    objectId: self.$data.nodeInfo.id
                });
                newClientSettingId = self.clientSettingId;
            }

            server.post('/modifyenforceclientsettingsassignment',
                {
                    templateId: newClientSettingId,
                    operationDataList: operations
                }
            ).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(self, 'Success', commonUtil.getMessageText(self.$i18n, "info_assign_client_setting"));
                        self.getInfo();
                        break;
                    case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                        commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_client_setting_already_changed"));
                        break;
                    default:
                        commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "modifyNodeClientSetting").replace("{code}", res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self,"modifyNodeClientSetting",error);
            });
            self.showEditNodeClientSetting = false;
        },
        getClientSettingName(settingId) {
            let self = this;
            self.clientSettingName = '';
            if (settingId == null || settingId === 0) {
                self.clientSettingName = commonUtil.getMessageText(self.$i18n,"item_value_noSetting");
                return;
            }
            server.post('/getenforceclientsettings',
                {
                    templateId: settingId
                })
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.clientSettingName = res.data.template.templateName;
                            break;
                        case constants.STATUS_ERROR_LICENSE_INSUFFICIENT:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_should_purchase_client_setting_option"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getClientSettingName").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "getClientSettingName", error);
                });
        },
        getClientSettingList: function() {
            let self = this;
            self.clientSettingList.splice(0, self.clientSettingList.length);
            server.post('/getenforceclientsettinglist')
                .then((res) => {
                    let settingName = commonUtil.getMessageText(self.$i18n,"item_value_noSetting");
                    let clientSettingRoot = {
                        settingId: 0,
                        settingName: settingName,
                    };
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            if (res.data.template.length === 0) {
                                commonUtil.notifyMessage(self, "Info", commonUtil.getMessageText(self.$i18n, "info_no_client_settings"));
                                break;
                            }
                            self.clientSettingList.push(clientSettingRoot);

                            for (let i = 0; i < res.data.template.length; i++) {
                                self.clientSettingList.push({
                                    settingId: res.data.template[i].templateId,
                                    settingName: res.data.template[i].templateName,
                                });
                            }
                            self.showEditNodeClientSetting = true;
                            break;
                        case constants.STATUS_ERROR_LICENSE_INSUFFICIENT:           // enforce client setting license not found.
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_should_purchase_client_setting_option"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getClientSettingList").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "getClientSettingList", error);
                });
        }
    },
    components: {
        deletenode: DeleteObject,
        confirmdeleteuser: DeleteObject,
        movenode: MoveNode,
        editnode: EditNode,
        addacl: AddACL,
        editTwoPhaseMethod: EditTwoPhaseMethod,
        editNodeClientSetting: EditNodeClientSetting
    },
    created: function() {
        return this.getInfo();
    },
    computed: {
        showAclEditCommand() {
            return commonUtil.canManageConsoleUserGroupDefinition(this.appData);
        },
        showAclDeleteCommand() {
            return commonUtil.canManageConsoleUserGroupDefinition(this.appData);
        }
    },
    watch: {
        selectedNode: {
            handler(newVal, oldVal) {
                if ((this.appData.importedTenantList.length > 0) || (this.appData.exportedTenantList.length > 0)) {
                    this.getConnectedTenantList();
                } else {
                    return this.getInfo();
                }
            }
        },
        '$route' (to, from) {
            if (to.name == "User") {
                if ((this.appData.importedTenantList.length > 0) || (this.appData.exportedTenantList.length > 0)) {
                    this.getConnectedTenantList();
                }
            }
        }
    },
    props: ['selectedNode', 'appData']
}

</script scoped>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
table {
    border-collapse: collapse;
}

tr {
    border-bottom:1px #eee solid;
}
.acluser-record:hover {
    background-color: #ecf1fa;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
.panel {
    background: #fff;
    padding: 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -150px;
    margin-top: -100px;
    transition: all .3s ease;
}
.modal-default-button {
  float: right;
}
.object-command-disabled {
    color: #848991;
    font-size: 12px;
}
.object-command-disabled img {
    opacity: 0.3;
}

.object-titlebox-left {
  position: absolute;
  padding: 10px;
  padding-left: 20px;
  color: #848991;
  font-size: 12px;
  vertical-align: middle;
}
.object-titlebox-right {
  padding: 10px;
  float: right;
  text-align : right;
  vertical-align: middle;
  font-size: 12px;
  height: 14px;
}
</style>
